import React from "react"
import useStore from "../../utils/useStore"

const SvgComponent = React.memo(({ item }) => {
    const selects = useStore((state) => state.selects)
    const selected = selects?.find((e) => e === item?.id)
    const editElements = useStore((state) => state.editElements)
    const addSelects = useStore((state) => state.addSelects)
    const setClickedPosition = useStore((state) => state.setClickedPosition)
    const setDragging = useStore((state) => state.setDragging)
    const dragging = useStore((state) => state.dragging)
    const setResizing = useStore((state) => state.setResizing)
    const resizing = useStore((state) => state.resizing)
    const editing = useStore((state) => state.editing)
    const setEditing = useStore((state) => state.setEditing)

    const onMouseDown = (event) => {
        window.getSelection().removeAllRanges()
        if (event?.shiftKey) {
            addSelects(item?.id, true)
        } else {
            addSelects(item?.id)
        }
        editElements("prevPosition", { x: item?.currPosition?.x, y: item?.currPosition?.y }, item?.id)
        editElements("preHeight", item?.style?.height, item?.id)
        editElements("preWidth", item?.style?.width, item?.id)
        setClickedPosition({ x: event.clientX, y: event.clientY })
        if (!selected && editing) {
            setEditing(false)
            setTimeout(() => {
                setDragging(true)
            }, 50);
        } else if (!selected) {
            setDragging(true)
        }
    }

    const onMouseHandleDown = (event, cursor, side) => {
        event.stopPropagation()
        window.getSelection().removeAllRanges()
        editElements("prevPosition", { x: item?.currPosition?.x, y: item?.currPosition?.y }, item?.id)
        editElements("preWidth", item?.style?.width, item?.id)
        editElements("preHeight", item?.style?.height, item?.id)
        setResizing({ cursor: cursor, side })
        setClickedPosition({ x: event.clientX, y: event.clientY })
    }

    return (
        <div className={selected ? 'Presentation_Image_Select Presentation_Image_Selected' : 'Presentation_Image_Select'} style={{ position: "absolute", transform: `translate(${item?.currPosition?.x}px, ${item?.currPosition?.y}px)`, cursor: resizing ? resizing?.cursor : dragging ? "move" : "default", userSelect: "none" }} onMouseDown={onMouseDown} onClick={(event) => {
            event.stopPropagation()
            if (!selected) {
                addSelects(item?.id)
            }
        }}>
            <ReplaceSvgColor value={item?.value} colors={item?.colors} style={item?.style} />
            {selected && !dragging ?
                <>
                    <div className='Presentation_Image_Handle Presentation_Image_Handle_LT' onMouseDown={(e) => onMouseHandleDown(e, 'nwse-resize', "top-left")} />
                    <div className='Presentation_Image_Handle Presentation_Image_Handle_LB' onMouseDown={(e) => onMouseHandleDown(e, 'nesw-resize', "bottom-left")} />
                    <div className='Presentation_Image_Handle Presentation_Image_Handle_RT' onMouseDown={(e) => onMouseHandleDown(e, 'nesw-resize', "top-right")} />
                    <div className='Presentation_Image_Handle Presentation_Image_Handle_RB' onMouseDown={(e) => onMouseHandleDown(e, 'nwse-resize', "bottom-right")} />
                </>
                : null}
        </div>
    )
})


const ReplaceSvgColor = React.memo(({ value, colors, style }) => {
    let values = value || ''
    colors?.forEach(colorMap => {
        const [originalColor, newColor] = Object.entries(colorMap)[0];
        const regex = new RegExp(originalColor, 'g');
        values = values?.replace(regex, newColor);
    })
    return <div style={{ display: "flex" }} dangerouslySetInnerHTML={{ __html: values?.replace('<svg ', `<svg width="${style?.width}" height="${style?.height}" opacity="${style?.opacity || 1}"`) }} />
})

export default SvgComponent;